import { Box, Chip } from '@material-ui/core'
import { useClasses } from './useClasses'
import { useFilter } from './useFilter'

export const Filter = () => {
  const {
    filterCollection,
    getTranslate,
    getActiveFilter,
    handleFilterRowClick,
  } = useFilter()
  const classes = useClasses()

  return (
    <Box className={classes.root}>
      {filterCollection.map(({ key, name, value }) => {
        return (
          <Chip
            key={key}
            className={classes.chip}
            label={getTranslate({ name })}
            data-activity={getActiveFilter({ value })}
            onClick={() => handleFilterRowClick({ key, name, value })}
          />
        )
      })}
    </Box>
  )
}
